import React, { useEffect, useState } from "react";
import "./SectionInput.css";
import { Accordion, Form } from "react-bootstrap";
import InputText from "./formelement/InputText";
import { useDispatch, useSelector } from "react-redux";
import { deleteSection, updateSection } from "../../REDUX/actions/section";

import Uploader from "../Common/Uploader";
import Lists from "../Lists/Lists";
import _ from "lodash";
import CustomSelect from "./formelement/CustomSelect";
import CarouselInput from "./formelement/CarouselInput";
import CustomButton from "../Common/CustomButton";
import { openModal } from "../../REDUX/actions/confirmationModal";
import LoadingButton from "../Common/LoadingButton";

// Mirrors how the Danaos website renders article sections
// (Danaos/src/sections/ArticleDetails): keep both in sync.
// The website renders any section image under the text, so "image" and "textImage"
// only differ here: `name` marks them (set by the toolbox presets) until an image is picked.
export const detectLayout = (section = {}) => {
  if (section.title === section.subtitle && section.title !== "") return "highlight";
  if (section.title === "Gallery") return "gallery";
  if (section.name === "image") return "image";
  if (!section.title && section.description?.includes("<i>")) return "quote";
  if (section.name === "text-image" || section.image?.data) return "textImage";
  return "text";
};

export const LAYOUT_LABELS = {
  text: "Text",
  textImage: "Text + image",
  highlight: "Highlight box",
  quote: "Quote",
  image: "Single image",
  gallery: "Gallery",
};

// Must stay a stable object (jodit-react rebuilds the editor when config changes).
// BR mode: the website renders the description inside a <p>, so no <p> wrappers.
const ARTICLE_EDITOR_CONFIG = { enter: "BR" };

const stripItalic = (html) => (html || "").replace(/<\/?i>/g, "");

const SectionInput = ({
  titleOrange,
  titleBlack,
  sectionData = {},
  withSeo,
  sectionId,
  defaultExpand,
  shadowed = true,
  deleteButton,
  type,
  eventItemForm,
  noBtn,
  fetchProduct,
  image2LabelInput,
  article, // "banner" | "section": article forms, limited to what the website displays
}) => {
  const dispatch = useDispatch();
  const layout = article === "section" ? detectLayout(sectionData) : null;
  const [image, setimage] = useState(sectionData.image?.data);
  const [image2, setimage2] = useState(sectionData.image2?.data);
  const [imageMobile, setImageMobile] = useState(sectionData.imageMobile?.data);
  const [imageMobile2, setImageMobile2] = useState(
    sectionData.imageMobile2?.data
  );
  const [carousel, setCarousel] = useState(sectionData?.carousel?.data || []);
  const [buttonUrl, setbuttonUrl] = useState(sectionData.buttonUrl);
  const { sectionLoading } = useSelector((state) => state.pagesReducer);
  const [formData, setformData] = useState(
    _.omit(sectionData, [
      "image",
      "image2",
      "imageMobile",
      "imageMobile2",
      "createdAt",
      "updatedAt",
      "list",
      "locale",
      "article",
      "carousel",
      "event",

      "page",
      "product",
      "revendeur",
      "resolution",
      "productjets",
      "articleBanner",
      "eventBanner",
    ])
  );
  useEffect(() => {
    setformData(
      _.omit(sectionData, [
        "image",
        "image2",
        "imageMobile",
        "imageMobile2",
        "createdAt",
        "updatedAt",
        "list",
        "locale",
        "article",
        "carousel",
        "event",

        "page",
        "product",
        "revendeur",
        "resolution",
        "productjets",
        "articleBanner",
        "eventBanner",
      ])
    );
    setimage(sectionData.image?.data);
    setimage2(sectionData.image2?.data);
    setImageMobile(sectionData?.imageMobile?.data);
    setImageMobile2(sectionData?.imageMobile2?.data);
    setCarousel(sectionData?.carousel?.data || []);
    setbuttonUrl(sectionData.buttonUrl);
    // eslint-disable-next-line
  }, [sectionData]);

  const handleSubmit = () => {
    dispatch(
      updateSection(
        {
          ...formData,
          buttonUrl: buttonUrl,
          image: image?.id,
          image2: image2 ? image2.id : null,
          imageMobile: imageMobile?.id,
          imageMobile2: imageMobile2?.id,
          carousel: carousel.map((img) => img.id),
        },
        sectionId
      )
    );
  };
  const handleChange = (value, champs) => {
    setformData({ ...formData, [champs]: value });
  };

  // The website shows a highlight box when title === subtitle.
  const handleHighlightValue = (value) => {
    setformData({ ...formData, title: value, subtitle: value });
  };

  const handleChangeButtonUrl = (value) => {
    setbuttonUrl(value);
  };

  const handleImage = (imageSelected) => {
    setimage(imageSelected);
  };
  const handleImage2 = (imageSelected) => {
    setimage2(imageSelected);
  };
  const handleImageMobile = (imageSelected) => {
    setImageMobile(imageSelected);
  };
  const handleImageMobile2 = (imageSelected) => {
    setImageMobile2(imageSelected);
  };
  const handleButtonShow = (value) => {
    setformData({ ...formData, showButton: value });
  };

  const handleDelete = () => {
    dispatch(deleteSection(sectionId, eventItemForm.id, type));
  };

  const showModalDelete = () => {
    dispatch(
      openModal({
        type: "delete",
        confirmButtonText: "Delete",
        cancelButton: true,
        message: "Are you sure you want to delete this section?",
        callBack: handleDelete,
      })
    );
  };

  const articleFields =
    article === "banner" ? (
      <div className="row align-items-center my-4">
        <div className="col-5 mx-w-280">
          <Uploader
            handleImage={handleImage}
            image={image}
            labelinput="Hero image"
          />
        </div>
        <div className="col">
          <InputText
            labelinput="Title"
            value={formData.title}
            handleChange={handleChange}
            champs="title"
            hideIfEmpty={false}
          />
          <InputText
            labelinput="Subtitle (part of the title shown in blue)"
            value={formData.subtitle}
            handleChange={handleChange}
            champs="subtitle"
            hideIfEmpty={false}
          />
        </div>
      </div>
    ) : (
      <div className="row my-4">
        {(layout === "text" || layout === "textImage") && (
          <>
            {sectionData.regularTitle ? (
              <InputText
                labelinput="Regular Title"
                value={formData.regularTitle}
                handleChange={handleChange}
                champs="regularTitle"
              />
            ) : null}
            <InputText
              labelinput='Menu label ("ON THIS PAGE", optional, must differ from the heading)'
              value={formData.title}
              handleChange={handleChange}
              champs="title"
              hideIfEmpty={false}
            />
            <InputText
              labelinput="Heading"
              value={formData.subtitle}
              handleChange={handleChange}
              champs="subtitle"
              hideIfEmpty={false}
            />
            <InputText
              labelinput="Body"
              textArea
              config={ARTICLE_EDITOR_CONFIG}
              value={formData.description}
              handleChange={handleChange}
              champs="description"
              hideIfEmpty={false}
            />
          </>
        )}
        {(layout === "textImage" || layout === "image") && (
          <div className="col-5 mx-w-280 my-3">
            <Uploader
              handleImage={handleImage}
              image={image}
              labelinput={
                layout === "image" ? "Image" : "Image (shown under the text)"
              }
            />
            {!image && (
              <p className="f14 text-grey mt-2">
                Pick an image, then click "Save".
              </p>
            )}
          </div>
        )}
        {layout === "highlight" && (
          <>
            <InputText
              labelinput='Highlight value (e.g. "5 days")'
              value={formData.subtitle}
              handleChange={handleHighlightValue}
              hideIfEmpty={false}
            />
            <InputText
              labelinput="Text"
              textArea
              config={ARTICLE_EDITOR_CONFIG}
              value={formData.description}
              handleChange={handleChange}
              champs="description"
              hideIfEmpty={false}
            />
            <p className="f14 text-grey text-start mt-2">
              Highlight boxes are displayed side by side: keep them at
              consecutive positions.
            </p>
          </>
        )}
        {layout === "quote" && (
          <div className="text-start pt-2 pb-2">
            <label className="f16">Quote</label>
            <Form.Control
              as="textarea"
              rows={3}
              value={stripItalic(formData.description)}
              onChange={(e) =>
                handleChange(`<i>${e.target.value}</i>`, "description")
              }
            />
            <p className="f14 text-grey mt-1">
              Keep it short (2 to 3 lines), the quote box has a fixed height.
            </p>
          </div>
        )}
        {layout === "gallery" && (
          <>
            <p className="f16 text-start mb-0">
              Title: <b>Gallery</b> (required by the website, only one gallery
              per article)
            </p>
            <CarouselInput images={carousel} setImages={setCarousel} />
          </>
        )}
        {layout !== "gallery" && sectionData.content ? (
          <InputText
            labelinput="Content: not displayed on the website, move this text into Body"
            textArea
            value={formData.content}
            handleChange={handleChange}
            champs="content"
          />
        ) : null}
        <div className="col-3">
          <InputText
            labelinput="Position"
            type="number"
            value={formData.order}
            handleChange={(value) =>
              handleChange(value === "" ? null : Number(value), "order")
            }
            hideIfEmpty={false}
          />
        </div>
      </div>
    );

  return (
    <Accordion
      className={`text-start rounded-10 ${shadowed ? "shadowed" : ""}`}
      defaultActiveKey={defaultExpand ? "0" : null}
    >
      <Accordion.Item
        className="card-body noBorder p-0 rounded-10"
        eventKey="0"
      >
        <Accordion.Header className="rounded-10">
          <h2 className="text-orange mb-0 f24 fw-bold">{titleOrange}</h2>
          <h2 className="mb-0 f24 fw-normal">{titleBlack}</h2>
          {layout && (
            <span className="ms-3 f16 text-grey">
              · {LAYOUT_LABELS[layout]}
            </span>
          )}
        </Accordion.Header>

        <Accordion.Body>
          <div className="container-fluid">
            {article ? articleFields : (<>
            <div className="row my-5">
              {sectionData.regularTitle !== null && sectionData.regularTitle !== "" ? (
                <div className="col-6">
                  <InputText
                    labelinput="Regular Title"
                    value={formData.regularTitle}
                    handleChange={handleChange}
                    champs="regularTitle"
                  />
                </div>
              ) : null}
              {sectionData.decoratedTitle !== null && sectionData.decoratedTitle !== "" ? (
                <div className="col-6">
                  <InputText
                    labelinput="Italic Blue Title"
                    value={formData.decoratedTitle}
                    handleChange={handleChange}
                    champs="decoratedTitle"
                  />
                </div>
              ) : null}
            </div>
            <div className="row align-items-center">
              {image && (
                <div className="col-6  d-flex flex-column align-items-center justify-content-center gap-5 mb-5">
                  <div className="row gap-3 w-100">
                    {image && (
                      <div className="col mx-w-280">
                        <Uploader
                          handleImage={handleImage}
                          image={image}
                          resolution={sectionData.resolution}
                          targetScreen="desktop"
                        />
                      </div>
                    )}
                    {image2 && (
                      <div className="col mx-w-280">
                        <Uploader
                          handleImage={handleImage2}
                          image={image2}
                          labelinput={image2LabelInput}
                          targetScreen="desktop 2"
                        />
                      </div>
                    )}

                    {imageMobile && (
                      <div className="col mx-w-280">
                        <Uploader
                          handleImage={handleImageMobile}
                          image={imageMobile}
                          resolution={sectionData.resolution}
                          targetScreen="mobile "
                        />
                      </div>
                    )}
                    {/* Uploader for imageMobile2 */}
                    {imageMobile2 && (
                      <div className="col mx-w-280">
                        <Uploader
                          handleImage={handleImageMobile2}
                          image={imageMobile2}
                          targetScreen="2 mobile"
                        />
                      </div>
                    )}
                  </div>
                </div>
              )}
              <div className="col ">
                {sectionData.title !== null && sectionData.title !== "" ? (
                  <InputText
                    labelinput="Title"
                    value={formData.title}
                    handleChange={handleChange}
                    champs="title"
                  />
                ) : null}
                {sectionData.subtitle !== null && sectionData.subtitle !== "" ? (
                  <InputText
                    labelinput="Subtitle"
                    value={formData.subtitle}
                    handleChange={handleChange}
                    champs="subtitle"
                  />
                ) : null}
                {!noBtn && (formData.showButton || formData.buttonText || buttonUrl) && (
                  <>
                    <div className="row mt-3 align-items-start">
                      {/* <div className="col-2">
                        <label className="f16 ">Show Button </label>
                        <Form.Switch
                          key={Math.random()}
                          defaultChecked={formData.showButton}
                          onChange={(e) => handleButtonShow(e.target.checked)}
                        ></Form.Switch>
                      </div> */}

                      {/* {formData.showButton && (
                        <div className="col">
                          <CustomSelect
                            handleChange={handleChangeButtonUrl}
                            value={buttonUrl}
                          />
                        </div>
                      )} */}
                    </div>
                    {formData.showButton && (
                      <div className="row pt-2 pb-2">
                        <div className="col">
                          <InputText
                            labelinput="Button Text"
                            value={formData.buttonText}
                            handleChange={handleChange}
                            champs="buttonText"
                          />
                        </div>
                        <div className="col">
                          <InputText
                            labelinput="Button URL"
                            value={buttonUrl}
                            flag={false}
                            readOnly
                            champs="buttonUrl"
                          />
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
              {sectionData.description !== null && sectionData.description !== "" ? (
                <div className="col-12">
                  <InputText
                    labelinput="Description"
                    textArea
                    value={formData.description}
                    handleChange={handleChange}
                    champs="description"
                  />
                </div>
              ) : null}
              {sectionData.content !== null || withSeo ? (
                <div className="col-12">
                  <InputText
                    labelinput="Content"
                    textArea
                    value={formData.content}
                    handleChange={handleChange}
                    champs="content"
                  />
                </div>
              ) : null}
            </div>
            {carousel.length > 0 && (
              <CarouselInput images={carousel} setImages={setCarousel} />
            )}
            </>)}
            <div className="row">
              <div className="col">
                <CustomButton
                  disabled={sectionLoading}
                  buttonText={
                    sectionLoading ? <LoadingButton /> : "Save"
                  }
                  callBack={handleSubmit}
                />
              </div>
              {deleteButton && (
                <div className="col-4">
                  <CustomButton
                    buttonText="Delete Section"
                    iconStart="trash-fill"
                    type="red"
                    callBack={showModalDelete}
                  />
                </div>
              )}
            </div>

            {sectionData.list?.data && (
              <Lists
                listData={sectionData.list.data}
                fetchProduct={fetchProduct}
              />
            )}
          </div>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default SectionInput;
